exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tour-overlay[data-v-fe6a1c38] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 9989;\n  pointer-events: none;\n}\n.tour-spotlight[data-v-fe6a1c38] {\n  position: fixed;\n  z-index: 9991;\n  border-radius: 8px;\n  -webkit-box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);\n          box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);\n  pointer-events: none;\n  -webkit-transition: top 0.3s ease, left 0.3s ease, width 0.3s ease, height 0.3s ease;\n  transition: top 0.3s ease, left 0.3s ease, width 0.3s ease, height 0.3s ease;\n}\n", ""]);

// exports
